// extracted by mini-css-extract-plugin
export var buttons = "questions-module--buttons--0878d";
export var intro = "questions-module--intro--d24dc";
export var questions = "questions-module--questions--af0da";
export var section = "questions-module--section--d270f";